// @ts-nocheck
import React, { ComponentType } from 'react';

import { useSelector } from 'react-redux';

import { RootState } from './types';

const withLoyaltyAccess = <P extends {}>(WrappedComponent: ComponentType<P>): React.FC<P> => {
  const WithLoyaltyAccess: React.FC<P> = (props) => {
    const hasLoyaltyAccess: boolean = useSelector((state: RootState) => state?.auth?.user.loyalty_access);
    if (!hasLoyaltyAccess) {
      // Render null if the user doesn't have loyalty access
      return null;
    }

    // Render the wrapped component if the user has loyalty access
    return <WrappedComponent {...props} />;
  };

  return WithLoyaltyAccess;
};

export default withLoyaltyAccess;
